
<div class="mobile-side-menu-container fixed inset-0 font-rubik">
  <div
    class="mobile-side-menu fixed top-0 left-0 bg-white h-full"
    :style="{ width: '90%' }"
  >
    <!-- Menu Content -->
    <div class="menu-content">
      <div
        class="menu-item"
        v-for="([key, item], index) in dropdownEntries"
        :key="key"
      >
        <!-- Dropdown Title -->
        <div
          :class="[
            'flex items-center justify-between p-4',
            {
              'border-b':
                activeDropdown !== item.name &&
                index !== dropdownEntries.length - 1,
            },
          ]"
          @click="toggleDropdown(item.name)"
        >
          <span class="dropdown-title">{{ item.name.toUpperCase() }}</span>
          <span>
            <img
              :class="{
                'rotate-up': activeDropdown === item.name,
                'rotate-down': activeDropdown !== item.name,
              }"
              src="@/images/header/drop-down-arrow.svg"
              alt="Arrow"
              class="arrow-icon"
            />
          </span>
        </div>
        <!-- Dropdown Links -->
        <div class="menu-dropdown" v-if="activeDropdown === item.name">
          <ul>
            <li
              v-for="(link, idx) in item.links"
              :key="idx"
              class="px-4 py-3 pl-8"
            >
              <a
                @click="closeDropdown()"
                class="dropdown-link flex items-center"
                :href="link.slug"
              >
                <span class="dropdown-link-name">{{ link.title }}</span>
                <img
                  class="h-4 ml-1"
                  src="@/images/service-area-cards/arrow-outward.svg"
                  alt="Arrow"
                />
              </a>
            </li>
            <!-- See All Link -->
            <div v-if="item.seeAll" class="flex items-center gap-2 pl-4 py-3">
              <a class="see-all-link" :href="item.seeAll.slug">Learn More</a>
              <img
                src="@/images/header/chevron-right.svg"
                alt="See all links"
              />
            </div>
          </ul>
        </div>
      </div>
    </div>
    <!-- Buttons at the bottom -->
    <div class="button-container flex justify-between px-4 py-4">
      <a
        :href="`tel:${formattedPhoneNumber}`"
        class="call-us-button flex-1 mr-2 py-3 rounded-full flex justify-center items-center"
      >
        <span>Call Us</span>
      </a>
      <button
        data-vue-init="lead-flow" 
        data-props='{ "gtag": "get_quote"}'
        class="get-quote-button flex-1 ml-2 text-center py-3 rounded-full flex justify-center items-center"
      >
        <span>Get Quote</span>
      </button>
    </div>
  </div>
</div>
